import Icon from '../../ui-kit/components/atoms/Icon'
import {CAKE_ICON} from '../../ui-kit/helpers/icons/cake'
import UserItem from '../../ui-kit/components/molecules/UserItem'

const BirthdaySection = () => {
  return (
    <section className="aside-section n-container">
      <h2 className="title title-base">
        <Icon size="20px" svg={CAKE_ICON} /> Cumpleaños
      </h2>
      <div className="list">
        <UserItem />
        <UserItem />
        <UserItem />
        <UserItem />
        <UserItem />
      </div>
    </section>
  )
}

export default BirthdaySection
